// extracted by mini-css-extract-plugin
export default {"changePassword":"styles_changePassword__n223h","oldPasswordGroup":"styles_oldPasswordGroup__god3h"};